import type React from 'react';
import styled from '@emotion/styled';

export type TagDetailsSectionProps = {
  title: string;
  children: React.ReactNode;
  /** Optional action buttons rendered in the header (e.g. edit/save/cancel icons). */
  actions?: React.ReactNode;
};

/** A bordered card section — equivalent to Tab.Pane.Pane + SidebarHeader + Divider. */
export const TagDetailsSection = ({ title, children, actions }: TagDetailsSectionProps) => (
  <Root>
    <Header>
      <Title>{title}</Title>
      {actions && <Actions>{actions}</Actions>}
    </Header>
    <Divider />
    <Body>{children}</Body>
  </Root>
);

TagDetailsSection.displayName = 'TagDetails.Section';

const Root = styled.div`
  box-sizing: border-box;
  border: 1px solid var(--sec-01);
  border-radius: 4px;
  padding: 18px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
`;

const Title = styled.div`
  font-family: var(--font-semibold);
  font-size: 20px;
  color: var(--black);
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Divider = styled.div`
  height: 1px;
  background: var(--gray-l);
  margin: 0;
`;

const Body = styled.div``;
